import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    setSnackBar
  } from "../../store/common/commonSlice";
import { setResetState, setShowPassword, signup } from "../../store/user/userSlice";

const mapStateToProps = (state) => {
  const {signup_is_loading,show_password,company_details} = state.user;
  return {
    signup_is_loading : signup_is_loading,
    show_password : show_password,
    company_details : company_details
  }
};

const mapDispatchToProps = (dispatch) => 
    bindActionCreators(
        {
          setShowPassword,
          setSnackBar,
          setResetState,
          signup
        },
        dispatch
    );

const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;